<template>
  <div id="content sticky-container" sticky-container>
    <template v-if="giftCard.enabled">
      <nav class="navbar navbar-expand-md fixed-top pt-0">
        <div class="container pl-0 pr-0" v-show="!buyTicketsButtonVisible">
          <div class="row mx-0" style="background-color: #fff; width: 100%;">
            <div class="col-md-6">
              <h4>
                {{ giftCard.title }}
              </h4>
            </div>

            <div class="col-md-6 pt-2">
              <b-button id="" v-b-modal.customGiftCardSelectionModal
                class="btn btn-primary col-md-5 col-sm=6">
                Buy Gift Card
              </b-button>
            </div>
          </div>
        </div>
      </nav>

      <div class="container" style="padding: 0px;">
        <div class="row no-gutters has-map fixed event-show-image-description" style="transform: none;">
          <div class="col-md-6"
            style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
            <div class="item-gallery item-gallery-custom">
              <div v-if="giftCard.image_url">
                <img :src="giftCard.image_url" class="img-fluid">
              </div>
              <div v-else class="text-center">
                <i class="fa fa-picture-o without-image" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div class="col-md-6"
            style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
            <div class="card card-custom">
              <div>
                <h3 class="mt-0 mb-0">
                  <i class="fa fa-gift" aria-hidden="true"></i>
                  {{ giftCard.title }}
                </h3>

                <div v-html="markedText(giftCard.description)"> </div>

                <b-row class="mt-auto">
                  <b-col cols="12" v-if="giftCard.limited_time_bonus_enabled && !giftCard.limited_time_bonus_out_of_date">
                    <h5>
                      Get a <strong>{{ giftCard.bonus_percentage }}% bonus!</strong>
                      <br />
                      <small> (until {{ giftCard.formatted_limited_time_bonus_date }}) </small>
                    </h5>
                  </b-col>

                  <b-col lg="6" md="6" sm="12" xs="12">
                    <div id="buy-gift-card-button" class="fixed-bottom-custom">
                      <b-button v-b-modal.customGiftCardSelectionModal
                        v-observe-visibility="visibilityChanged"
                        class="btn btn-primary btn-block">
                        Buy Gift Card
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br/>

      <div class="container">
        <div class="row no-gutters has-map fixed" style="transform: none;">
          <div class="col-md-6 col-lg-5 col-xl-6"
            style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
            <div class="item-description">
              <h3 class="headline mt-0">Organizer Details</h3>
              <strong> {{ giftCard.organizer_name }} </strong>
              <p> {{ giftCard.organizer_description }} </p>

              <template v-if="giftCard.organizer_website">
                <a :href="giftCard.organizer_website" target="_blank">
                  {{ giftCard.organizer_website }}
                </a>
                <br/>
              </template>

              <template v-if="giftCard.organizer_contact_phone_number">
                <a :href="`tel:+1${extracNumbers(giftCard.organizer_contact_phone_number)}`"
                  rel="nofollow">
                  {{ giftCard.organizer_contact_phone_number }}
                </a>
                <br/>
              </template>

              <template v-if="giftCard.organizer_facebook_id">
                <a :href="socialMediaLinks(giftCard.organizer_facebook_id, 'facebook')" target="_blank">
                  <i class="fa fa-facebook-official" aria-hidden="true"></i>
                  {{ giftCard.organizer_facebook_id }}
                </a>
                <br/>
              </template>

              <template v-if="giftCard.organizer_twitter_id">
                <a :href="socialMediaLinks(giftCard.organizer_twitter_id, 'twitter')" target="_blank">
                  <i class="fa fa-twitter" aria-hidden="true"></i>
                  {{ giftCard.organizer_twitter_id }}
                </a>
                <br/>
              </template>

              <template v-if="giftCard.organizer_instagram_id">
                <a :href="socialMediaLinks(giftCard.organizer_instagram_id, 'instagram')" target="_blank">
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                  {{ giftCard.organizer_instagram_id }}
                </a>
                <br/>
              </template>

              <b-button v-b-modal.formContactModal class="btn btn-primary col-lg-8 mt-3">
                Contact Us
              </b-button>

              <ContactForm
                :giftCard="giftCard">
              </ContactForm>
            </div>
          </div>
        </div>
      </div>

      <CustomGiftCardSelectionModal
        :giftCard="giftCard"
      />

      <script v-html="giftCardStructuredData" type="application/ld+json" />
    </template>

    <template v-else>
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12">
            <b-alert show v-show="!loading" style="background-color: #fff;">
              <h6> There are no gift cards available. </h6>
            </b-alert>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ContactForm from '../../common/ContactForm'
import CustomGiftCardSelectionModal from './CustomGiftCardSelectionModal'
import StructuredData from '../../common/StructuredData'
import GiftCardPublicService from '@/services/GiftCardPublicService'
import { ObserveVisibility } from 'vue-observe-visibility'

export default {
  name: 'GiftCardShow',
  components: {
    ContactForm,
    CustomGiftCardSelectionModal
  },
  directives: {
    ObserveVisibility
  },
  mixins: [StructuredData],
  data: () => {
    return {
      buttonSticked: false,
      buyTicketsButtonVisible: true,
      loading: true,
      giftCard: {
        needLoading: true,
        enabled: false
      },
      giftCardStructuredData: {}
    }
  },
  created () {
    this.loadCustomGiftCardStructuredData(`url_site=${window.location.hostname}`)

    if (this.giftCard.needLoading) {
      this.loadGiftCard()
    }
    window.scrollTo(0, 0)
  },
  head () {
    if (!this.giftCard.needLoading) {
      let giftCardTitle = this.giftCard.title
      let giftCardDescription = this.giftCard.description
      let url = window.location.href
      let socialImageUrl = this.profileSocialImageUrl(this.$parent.siteConfiguration)
      let twitterAccount = this.profileTwitterAccount(this.$parent.siteConfiguration)

      return {
        meta: this.dynamicMetaTags(giftCardTitle, giftCardDescription, url, socialImageUrl, twitterAccount),
        script: this.gaTagBuilder
      }
    } else {
      return []
    }
  },
  methods: {
    loadGiftCard () {
      const self = this
      const loader = this.$loading.show()
      const domainName = this.$route.params['domain_name']

      GiftCardPublicService.getGiftCardByUrl(domainName).then((response) => {
        const [gc] = response.data

        if (gc) {
          self.giftCard = gc
          self.giftCard.needLoading = false
          self.$emit('updateHead')
        }
      }).finally(() => {
        self.loading = false
        loader.hide()
      })
    },
    visibilityChanged (isVisible, entry) {
      this.buyTicketsButtonVisible = isVisible
    }
  }
}
</script>
